import { BRANDID, COOKIE_NAMES, DEFAULT_COOKIE_ACTIVE_DAYS } from './constants';
import { getCookieValue, setCookie } from './cookie';

import {
  onFocus,
  isLeadInfoValid,
  setPhoneFlagAttributes,
  highlightInvalidFields,
  getRefinedLeadInfo,
  processLeadRegistration,
  getSanitizedInput,
  showPlansFold,
} from './utlils/registerUtils';

let leadInfo = {};
let leadInfoAdLp = {};
const registerBtn = document.querySelector('#register');
const paidAdLpRegisterBtn = document.querySelector('#paid-ad-lp-register');

const isFromFranchise = document.referrer.includes('franchise') || document.referrer.includes('ifa-team-human') || (document.location.pathname.includes('franchise') && document.referrer === '');

const isRegistrationPage = document.location.pathname === '/view-pricing';
const isPromoRegistrationPage = document.location.pathname === '/viewpricing';
const isReferAFriendPage = window.location.pathname.includes(
  'redeem-your-referral',
);
const isFromChimePage = document.referrer
  .toLowerCase()
  .includes('utm_source=chime');

if (isFromChimePage) setCookie('isFromChimePage', 'true', 365);


if (isRegistrationPage && isFromFranchise) {
  const contactNumberButton = document.querySelector('#salesContactNumber');
  const contactNumberElementMobile = document.querySelector(
    '#salesContactNumberForMobile',
  );
  const salesEmailElement = document.querySelector('#salesEmailId');
  contactNumberButton.setAttribute('href', 'tel:+18005840234');
  contactNumberButton.textContent = '800-584-0234';
  contactNumberElementMobile.setAttribute('href', 'tel:+18005840234');
  salesEmailElement.setAttribute(
    'href',
    'mailto:franchisesales@answerconnect.com',
  );
  salesEmailElement.textContent = 'franchisesales@answerconnect.com';
}

if (document.referrer.indexOf('acn-network') !== -1) {
  setCookie('isFromACN', 'true', 365);
}

function onBlur(event, info) {
  const userInput = event.target.value;
  if (getSanitizedInput(userInput) !== userInput) {
    event.target.classList.add('invalid');
    if (event.target.id.includes('paid-ad-lp')) {
      leadInfoAdLp[info.emittedBy] = '';
      leadInfoAdLp[info.emittedBy] = false;
    } else {
      leadInfo[info.emittedBy].value = '';
      leadInfo[info.emittedBy].valid = false;
    }
  } else if (event.target.id.includes('paid-ad-lp')) {
    leadInfoAdLp[info.emittedBy] = info;
  } else {
    leadInfo[info.emittedBy] = info;
  }
}

function leadInfoObject(
  phoneFieldID,
  emailFieldID,
  nameFieldID,
  companyFieldID,
) {
  return {
    fields: {
      phone: {
        selector: phoneFieldID,
        type: 'phone',
        withDialCodePicker: true,
        country: (window.siteInfo && window.siteInfo.country) || 'US',
        errorClassName: 'invalid',
      },
      ...(document.querySelector(companyFieldID) && {
        company: {
          selector: companyFieldID,
          type: 'text',
          errorClassName: 'invalid',
        },
      }),
      mail: {
        selector: emailFieldID,
        type: 'email',
        errorClassName: 'invalid',
      },
      name: { selector: nameFieldID, type: 'text', errorClassName: 'invalid' },
    },
    eventListeners: {
      blur: onBlur,
      focus: onFocus,
    },
  };
}
leadInfo = window.InputValidator
  && window.InputValidator.fields.initialize({
    ...leadInfoObject('#phone', '#email', '#name', '#company'),
  });

leadInfoAdLp = window.InputValidator
  && window.InputValidator.fields.initialize({
    ...leadInfoObject(
      '#paid-ad-lp-phone',
      '#paid-ad-lp-email',
      '#paid-ad-lp-name',
    ),
  });


const successCallback = (response) => {
  if (response?.isTest === 'true') {
    setCookie(COOKIE_NAMES.IS_TEST_REGISTERED, 'true', DEFAULT_COOKIE_ACTIVE_DAYS);
  }

  if (isFromFranchise) {
    setCookie('isFromFranchiseRegistration', true, 365);
  }
  window.location.href = isPromoRegistrationPage ? '/plans-promo' : '/plans';
};

const failureCallback = () => {
  registerBtn.removeAttribute('style');
  document.getElementById('registration').classList.remove('loading');
  if (document.getElementById('paid-ad-registration')) {
    document.getElementById('paid-ad-registration').classList.remove('loading');
  }
  setCookie('isFromFranchise', '', -1); // Removing the cookie if the registration fails
};

function registrationCTAHandler(event) {
  let infoObj = {};
  if (event.target.id === 'paid-ad-lp-register') {
    infoObj = leadInfoAdLp;
  } else {
    infoObj = leadInfo;
  }

  if (isLeadInfoValid(infoObj)) {
    if (isFromFranchise) {
      setCookie('isFromFranchise', 'true', 365);
    }
    registerBtn.setAttribute(
      'style',
      'pointer-events: none;cursor: default;',
    );
    document.getElementById('registration').classList.add('loading');
    if (document.getElementById('paid-ad-registration')) {
      document.getElementById('paid-ad-registration').classList.add('loading');
    }
    const isViewPricing = window.location.href.includes('/viewpricing');
    const payload = getRefinedLeadInfo(infoObj);
    processLeadRegistration(
      {
        ...payload,
        brandid: BRANDID,
        cookie: document.cookie,
        referrer: document.referrer || window.location.href,
        ...(isViewPricing && { source: 'v1' }),
        ...(isReferAFriendPage && {
          reference: 'Referral',
          referrerContactId: getCookieValue('referrerContactId'),
        }),
        timezone: window.getUserTimezone && window.getUserTimezone(),
      },
      successCallback,
      failureCallback,
    );
  } else if (infoObj && Object.keys(infoObj).length) {
    highlightInvalidFields(infoObj);
  }
}

if (registerBtn) {
  registerBtn.addEventListener('click', registrationCTAHandler);
}

if (paidAdLpRegisterBtn) {
  paidAdLpRegisterBtn.addEventListener('click', registrationCTAHandler);
}

window.addEventListener('pageshow', () => {
  const uniquePin = getCookieValue('uniquePin');
  const isRegistered = getCookieValue('isregistered');
  if (isRegistered && uniquePin) {
    showPlansFold(uniquePin);
  }
});

// Intltel Input Accessibility
window.addEventListener('load', () => setPhoneFlagAttributes());
